import { PPMDataEntity } from "../entites/ppm.entity";
import { PPMExcelUploadDto } from "./ppm-excel-upload.dto";

export class PPMAdapter {

    public convertDtoToEntity(dto: PPMExcelUploadDto): PPMDataEntity {
        const entity = new PPMDataEntity()

        entity.bomItem = dto.bomItem
        entity.documentDate = dto.documentDate
        entity.purchaseOrderNumber = dto.purchaseOrderNumber
        entity.poLineItemNumber = dto.poLineItemNumber
        entity.styleNumber = dto.styleNumber
        entity.productCode = dto.productCode
        entity.colorDesc = dto.colorDesc
        entity.destinationCountry = dto.destinationCountry
        entity.plant = dto.plant
        entity.directShipSONumber = dto.directShipSONumber
        entity.directShipSOItemNumber = dto.directShipSOItemNumber
        entity.customerPO = dto.customerPO
        entity.shipToCustomerNumber = dto.shipToCustomerNumber
        entity.shipToCustomerName = dto.shipToCustomerName
        entity.planningSeasonCode = dto.planningSeasonCode
        entity.planningSeasonYear = dto.planningSeasonYear
        entity.OGAC = dto.OGAC
        entity.GAC = dto.GAC
        entity.shippingType = dto.shippingType
        entity.geoCode = dto.geoCode
        entity.DPOMLineItemStatus = dto.DPOMLineItemStatus
        entity.inventorySegmentCode = dto.inventorySegmentCode
        entity.totalItemQty = dto.totalItemQty
        entity.VASSize = dto.VASSize
        entity.sizeQuantity = dto.sizeQuantity
        entity.sizeDescription = dto.sizeDescription
        entity.genderAgeDesc = dto.genderAgeDesc
        entity.itemVasText = dto.itemVasText
        entity.productName = dto.productName
        entity.poAndLine = dto.poAndLine
        entity.odVersion = dto.odVersion
        entity.fileId = dto.fileId

        return entity
    }
}